// @flow strict
import { Empty, Row, Spin } from 'antd';
import React, { useEffect, useState } from "react";
import { getPricingPlans } from '../../api/pricing';
import { userSubscriptionInfo } from "../../api/profile";
import PlanCard from "./PlanCard";

function PricingPlans() {
  const [plans, setPlans] = useState([]);
  const [subscription, setSubscription] = useState(null);
  const [activePlan, setActivePlan] = useState(null);
  const [fetching, setFetching] = useState(false);

  // Function to fetch both pricing plans and user subscription info
  const fetchData = async () => {
    setFetching(true);
    try {
      // Fetch pricing plans
      const pricingRes = await getPricingPlans();
      if (pricingRes?.data?.plans) {
        setPlans(pricingRes.data.plans);
      }

      // Fetch user subscription info
      const subscriptionRes = await userSubscriptionInfo();
      setSubscription(subscriptionRes?.subscription);
      setActivePlan(subscriptionRes?.activePlan);
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    };
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container py-4 pricing-page">
      <div className="pricing-page-header">
        <p className="pricing-page-title">Pricing Comparison</p>
        <p classNam="pricing-page-desc">
          Our pricing plans are simple and transparent, and it's free to get started.
        </p>
      </div>
      {
        fetching ?
          <Spin spinning={fetching} tip="Loading data...">
            <div className="py-5"></div>
          </Spin> :
          <>
            {
              (plans?.length > 0 && activePlan) ?
                <Row gutter={[16, 32]} className="pricing-cards">
                  {
                    plans.map((plan, index) => (
                      <PlanCard
                        key={index}
                        plan={plan}
                        plans={plans}
                        activePlan={activePlan}
                        subscription={subscription}
                        setActivePlan={setActivePlan}
                      />
                    ))
                  }
                </Row>
                :
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            }
          </>
      }
    </div>
  );
};

export default PricingPlans;